import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -6","key":"svg-0"}],["path",{"d":"M11 16a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M8 11v-5a4 4 0 0 1 8 0","key":"svg-2"}]]

const IconLockOpen = createReactComponent('outline', 'lock-open', 'LockOpen', __iconNode);

export default IconLockOpen;